export default [
  'str',
  'dex',
  'con',
  'int',
  'wis',
  'cha',
];
